export { default as Pagination, type PaginationProps } from './Pagination';
